<template>
<div id="Navbar">
    <b-navbar type="light" variant="light" toggleable="md" v-if="loginfromapp != 'S'">
        <b-navbar-brand>
            <h2 style="margin-bottom: 15px;" class="border-white">{{appname}}</h2>          
        </b-navbar-brand>
      
        <b-collapse is-nav id="nav_dropdown_collapse">
           
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
                <b-nav-item-dropdown right>
                    <!-- Using button-content slot -->
                    <template slot="button-content">
                        <em>{{ user }}</em>
                    </template>
                    <b-dropdown-item>
                        <router-link to="/ute/logout">Logout</router-link>
                    </b-dropdown-item>
                </b-nav-item-dropdown>
            </b-navbar-nav>
        </b-collapse>

    </b-navbar>
</div>
</template>

<script>

export default {
    name: 'Navbar',
    methods: {

    },
    data: function () {

        var nome = localStorage.getItem('nome') || '';
        var cognome = localStorage.getItem('cognome') || '';
        var idsocio = localStorage.getItem('idsocio');

        return {
            user: nome + ' ' + cognome,
            idsocio: idsocio,
            loginfromapp: localStorage.getItem('loginfromapp') || 'N',
            appname: localStorage.getItem('appname') || '',
        };

    },
}
</script>

<style scoped>
#nav-home {
    color: rgba(0, 0, 0, .5);
    text-decoration: none;
}

#nav-home:hover,
#nav-home:active {
    color: #4A4A4B;
}

.border-white{
  /*border white with light shadow*/
  text-shadow: 
     0.8px  0.8px     #fff, 
    -0.8px  0.8px     #fff, 
     0.8px -0.8px     #fff, 
    -0.8px -0.8px     #fff,
     0.8px  0.8px 5px #555;
}
</style>
